const getEnvironmentMode = () => {
    const mode = process.env.REACT_APP_ENV_MODE || "production";
    return mode;
  };
  
  export default getEnvironmentMode;